export interface CampoContaMetadata { nome: string; label: string; tipo: string; tamanho: number; precisao: number; obrigatorio: boolean; leitura: boolean; ordem: number; aba: string; opcoes: Array<{ valor: string; label: string }>; }

export const CAMPOS_CONTA: CampoContaMetadata[] = [
  {
    "nome": "CARTEIRA",
    "label": "Carteira",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 18,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "NOSSONUMATIVO",
    "label": "Usar geração de Nosso Número",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 62,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "NUMCHEQ",
    "label": "Último nro. cheque",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 14,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "NUMCLIENTE",
    "label": "Número do cliente",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 49,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "SEQREM2",
    "label": "Sequência remessa alternativa",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 26,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "TIPMULTIPSOMA",
    "label": "Ao somar as multiplicações",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 53,
    "aba": "",
    "opcoes": [
      {
        "valor": "D",
        "label": "Somar dígito a dígito dos totais"
      },
      {
        "valor": "T",
        "label": "Somar os totais da multiplicação"
      }
    ]
  },
  {
    "nome": "IMPBOLETA",
    "label": "Impressora",
    "tipo": "S",
    "tamanho": 32,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 33,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "DIGITOSUBST3",
    "label": "substitui por:",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 61,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "DTIMPLANT",
    "label": "Referência p/ aceitar lançamentos",
    "tipo": "D",
    "tamanho": 7,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": true,
    "ordem": 8,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "SEQREM",
    "label": "Sequência remessa",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 24,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CHAVEPIX",
    "label": "Chave pix",
    "tipo": "S",
    "tamanho": 77,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 88,
    "aba": "Pix",
    "opcoes": []
  },
  {
    "nome": "CTADEFEMIBOL",
    "label": "Conta padrão para emissão",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 32,
    "aba": "",
    "opcoes": [
      {
        "valor": "N",
        "label": "Não"
      },
      {
        "valor": "S",
        "label": "Sim"
      }
    ]
  },
  {
    "nome": "CODCTABCOINT",
    "label": "Código da conta bancária",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 0,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "DIASPROTESTO",
    "label": "Dias para protesto",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 107,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "UTILIZAPIXPDV",
    "label": "Utiliza PIX PDV",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 92,
    "aba": "Pix",
    "opcoes": [
      {
        "valor": "S",
        "label": "Sim"
      },
      {
        "valor": "N",
        "label": "Não"
      }
    ]
  },
  {
    "nome": "PJBCHAVE",
    "label": "Chave",
    "tipo": "S",
    "tamanho": 80,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 0,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "MULTIPNOSSONUM",
    "label": "Multiplicadores",
    "tipo": "S",
    "tamanho": 25,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 52,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "NUMBENEFICIARIO",
    "label": "Número Beneficiário",
    "tipo": "S",
    "tamanho": 20,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 50,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "VALORJUROS",
    "label": "Valor juros",
    "tipo": "F",
    "tamanho": 6,
    "precisao": 2,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 102,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODCTABENEF",
    "label": "Conta Beneficiário",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 66,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "SALDOBCO",
    "label": "Saldo do banco na referência",
    "tipo": "F",
    "tamanho": 126,
    "precisao": 2,
    "obrigatorio": false,
    "leitura": true,
    "ordem": 9,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "REMBCO",
    "label": "Último boleto",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 28,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "SENCLIPIX",
    "label": "Client Secret Pix",
    "tipo": "S",
    "tamanho": 1000,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 86,
    "aba": "Pix",
    "opcoes": []
  },
  {
    "nome": "QTDDIASVALPIX",
    "label": "Qtd. Dias Val. Pix após Venc",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 90,
    "aba": "Pix",
    "opcoes": []
  },
  {
    "nome": "VLRMINBOLETA",
    "label": "Valor mínimo",
    "tipo": "F",
    "tamanho": 126,
    "precisao": 2,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 36,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODCTABCO",
    "label": "Conta",
    "tipo": "S",
    "tamanho": 17,
    "precisao": 0,
    "obrigatorio": true,
    "leitura": false,
    "ordem": 1,
    "aba": "__main",
    "opcoes": []
  },
  {
    "nome": "CODCTABCOINTREM",
    "label": "Conta p/controlar a seq.de remessa",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 23,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODCTACTB",
    "label": "Conta contábil",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 6,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "NUMCONTARURAL",
    "label": "Número da conta Produtor Rural",
    "tipo": "S",
    "tamanho": 3,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 77,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "DIASJURO",
    "label": "Dias Juros",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 114,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODLANCBAIXABOLRAP",
    "label": "Lançamento baixa boleto",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 28,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "SUBRESTMODULO",
    "label": "Substitui resto:",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 55,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CATEGLANCHQ",
    "label": "Categoria p/ lançamento de cheque",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 47,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODAGEBENEF",
    "label": "Agência Beneficiário",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 65,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "SALDOREAL",
    "label": "Saldo real na referência",
    "tipo": "F",
    "tamanho": 126,
    "precisao": 2,
    "obrigatorio": false,
    "leitura": true,
    "ordem": 10,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "REMFINAL",
    "label": "Nro máx.p/seq.remessa",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 25,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "LINHADIGATIVO",
    "label": "Usar geração da Linha Digitável",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 63,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CTAMINBOLETA",
    "label": "Alterar p/outra conta",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 37,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "DESCRICAO",
    "label": "Descrição",
    "tipo": "S",
    "tamanho": 40,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 2,
    "aba": "__main",
    "opcoes": []
  },
  {
    "nome": "TIPOBOLETO",
    "label": "Tipo Boleto",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 0,
    "aba": "",
    "opcoes": [
      {
        "valor": "R",
        "label": "RAPIDO"
      },
      {
        "valor": "P",
        "label": "CNAB"
      },
      {
        "valor": "A",
        "label": "AVANCADO"
      },
      {
        "valor": "I",
        "label": "PIX"
      }
    ]
  },
  {
    "nome": "CODCONTARURAL",
    "label": "Classificação da conta Produtor Rural",
    "tipo": "S",
    "tamanho": 3,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 76,
    "aba": "",
    "opcoes": [
      {
        "valor": "000",
        "label": "000 - Caixa"
      },
      {
        "valor": "999",
        "label": "999 - Em trânsito"
      }
    ]
  },
  {
    "nome": "BJBBAIBOLPAG",
    "label": "Baixar o tílulo quando o boleto for pago",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 0,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "IDAPIBANCO",
    "label": "Sequência remessa alternativa",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 90,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "REMBCOMAX",
    "label": "Número máximo",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 29,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODCTABAIXA",
    "label": "Conta p/ baixa (Processamento de Retorno)",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 67,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "NUCONTRATO",
    "label": "Nro. Contrato",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 46,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "PJBCRED",
    "label": "Credencial",
    "tipo": "S",
    "tamanho": 80,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 0,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "VALORMULTA",
    "label": "Valor multa",
    "tipo": "F",
    "tamanho": 6,
    "precisao": 2,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 103,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "TIPMODNOSSNUM",
    "label": "Tipo do Módulo",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 54,
    "aba": "",
    "opcoes": [
      {
        "valor": "O",
        "label": "Módulo 11"
      },
      {
        "valor": "D",
        "label": "Módulo 10"
      }
    ]
  },
  {
    "nome": "CONVENIO",
    "label": "Convênio",
    "tipo": "I",
    "tamanho": 126,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 19,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "RESTOSUBST3",
    "label": "Se resto igual:",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 58,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "TAXA",
    "label": "Ou cobrar taxa",
    "tipo": "F",
    "tamanho": 126,
    "precisao": 2,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 38,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODBCO",
    "label": "Banco",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": true,
    "leitura": false,
    "ordem": 3,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "DESCONSLCDPR",
    "label": "Desc. Conta na Ger. do Livro Cx Dig. do Prod. Rural",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 457,
    "aba": "",
    "opcoes": [
      {
        "valor": "S",
        "label": "Sim"
      },
      {
        "valor": "N",
        "label": "Não"
      }
    ]
  },
  {
    "nome": "ZERARAUT",
    "label": "Zerar automaticamente",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 30,
    "aba": "",
    "opcoes": [
      {
        "valor": "N",
        "label": "Não"
      },
      {
        "valor": "S",
        "label": "Sim"
      }
    ]
  },
  {
    "nome": "EXCLUSIVA",
    "label": "Exclusiva da empresa",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 11,
    "aba": "Cadastros",
    "opcoes": [
      {
        "valor": "S",
        "label": "Sim"
      },
      {
        "valor": "N",
        "label": "Não"
      }
    ]
  },
  {
    "nome": "CODCORRBCO",
    "label": "Correspondente bancário",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 17,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "RESTOSUBST2",
    "label": "Se resto igual:",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 57,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "INSTRUCAOI",
    "label": "Instrução I",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 20,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODPARC",
    "label": "Cód. Parceiro",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 7,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "CODAGE",
    "label": "Agência bancária",
    "tipo": "S",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": true,
    "leitura": false,
    "ordem": 4,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "CHAVEAPIPIX",
    "label": "Chave da API Pix",
    "tipo": "S",
    "tamanho": 250,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 85,
    "aba": "Pix",
    "opcoes": []
  },
  {
    "nome": "INDNOSSONUM",
    "label": "Indicador do Nosso Número",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 68,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "INSTRUCAONEGATIVACAO",
    "label": "Instrução de negativação",
    "tipo": "I",
    "tamanho": 4,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 109,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CONTABILIZARDIAS",
    "label": "Contabilizar dia útil ou dias corridos",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 110,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "MODBOLETA",
    "label": "Modelo",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 35,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "REMFINAL2",
    "label": "Nro máx.p/seq.remessa alternativa",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 27,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "RESTOSUBST1",
    "label": "Se resto igual:",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 56,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "INSTRUCAOII",
    "label": "Instrução II",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 21,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "DIGITOSUBST2",
    "label": "substitui por:",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 60,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "DVC_OBSCOMEX",
    "label": "Observações Proforma",
    "tipo": "C",
    "tamanho": 4000,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 0,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODEMP",
    "label": "Empresa",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 5,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "CONCAUTRECEBPIX",
    "label": "Conciliar automaticamente os recebimentos via API",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 91,
    "aba": "Pix",
    "opcoes": [
      {
        "valor": "N",
        "label": "Não"
      },
      {
        "valor": "S",
        "label": "Sim"
      }
    ]
  },
  {
    "nome": "AD_IMPRIMEORCAMENTO",
    "label": "Imprime no Orçamento?",
    "tipo": "S",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 458,
    "aba": "",
    "opcoes": [
      {
        "valor": "S",
        "label": "Sim"
      },
      {
        "valor": "N",
        "label": "Não"
      }
    ]
  },
  {
    "nome": "INSTRUCAOPROTESTO",
    "label": "Instrução de protesto",
    "tipo": "I",
    "tamanho": 4,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 108,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "ATIVA",
    "label": "Ativa",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 12,
    "aba": "Cadastros",
    "opcoes": [
      {
        "valor": "S",
        "label": "Sim"
      },
      {
        "valor": "N",
        "label": "Não"
      }
    ]
  },
  {
    "nome": "PJBCONBAIXCRED",
    "label": "Conciliar a baixa do titulo ao receber o crédito",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 0,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODTIPOPERBAIXABOLRAP",
    "label": "TOP Baixa boleto",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 28,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "NOSSONUMERO",
    "label": "Configuração do Nosso Número",
    "tipo": "S",
    "tamanho": 25,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 51,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "LOGOURL",
    "label": "Guarda logomarca",
    "tipo": "S",
    "tamanho": 4000,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 0,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "DIASPROT",
    "label": "Dias para protesto",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 22,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODMOEDA",
    "label": "Moeda",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 16,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "DIGITOSUBST1",
    "label": "substitui por:",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 59,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CODOPEREXCL",
    "label": "Operador exclusivo",
    "tipo": "I",
    "tamanho": 5,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 15,
    "aba": "Cadastros",
    "opcoes": []
  },
  {
    "nome": "CLASSE",
    "label": "Tipo de conta",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 13,
    "aba": "Cadastros",
    "opcoes": [
      {
        "valor": "A",
        "label": "Aplicação"
      },
      {
        "valor": "Z",
        "label": "Caixa (PDV)"
      },
      {
        "valor": "X",
        "label": "Caixa-Tesouraria"
      },
      {
        "valor": "S",
        "label": "Sócios"
      },
      {
        "valor": "O",
        "label": "Outros"
      },
      {
        "valor": "M",
        "label": "Comissões"
      },
      {
        "valor": "C",
        "label": "Corrente"
      },
      {
        "valor": "D",
        "label": "Adiantamento"
      },
      {
        "valor": "E",
        "label": "Empréstimo"
      },
      {
        "valor": "G",
        "label": "Garantida"
      }
    ]
  },
  {
    "nome": "IDCLIPIX",
    "label": "Client ID Pix",
    "tipo": "S",
    "tamanho": 250,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 87,
    "aba": "Pix",
    "opcoes": []
  },
  {
    "nome": "DIASMULTA",
    "label": "Dias Multa",
    "tipo": "I",
    "tamanho": 10,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 104,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "CAMPOLIVRE",
    "label": "Campo Livre",
    "tipo": "S",
    "tamanho": 25,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 50,
    "aba": "",
    "opcoes": []
  },
  {
    "nome": "EMITEBOLETA",
    "label": "Emite",
    "tipo": "S",
    "tamanho": 1,
    "precisao": 0,
    "obrigatorio": false,
    "leitura": false,
    "ordem": 31,
    "aba": "",
    "opcoes": [
      {
        "valor": "N",
        "label": "Não"
      },
      {
        "valor": "S",
        "label": "Sim"
      }
    ]
  }
];
